if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}


/* LT-ELEGANT-GALLERY-20261018 */
(function(){
 const C=customElements.get('product-modal');
 if(!C||C.prototype.ltGalleryInstalled)return;
 C.prototype.ltGalleryInstalled=true;
 const original=C.prototype.show;
 C.prototype.show=function(opener){
   original.call(this,opener);
   const content=this.querySelector('.product-media-modal__content');
   const dialog=this.querySelector('.product-media-modal__dialog');
   if(!content||!dialog)return;
   const items=[...content.children].filter(x=>x.matches('[data-media-id]'));
   if(!items.length)return;
   let nav=this.querySelector('.lt-gallery-nav');
   if(!nav){
     nav=document.createElement('nav');nav.className='lt-gallery-nav';nav.setAttribute('aria-label','Fotografie del prodotto');
     const back=document.createElement('button');back.type='button';back.className='lt-gallery-arrow';back.textContent='‹';back.setAttribute('aria-label','Foto precedente');
     const strip=document.createElement('div');strip.className='lt-gallery-strip';
     const next=document.createElement('button');next.type='button';next.className='lt-gallery-arrow';next.textContent='›';next.setAttribute('aria-label','Foto successiva');
     nav.append(back,strip,next);dialog.append(nav);
     nav.ltBack=back;nav.ltNext=next;nav.ltStrip=strip;
   }
   const strip=nav.ltStrip;strip.replaceChildren();
   let index=Math.max(0,items.findIndex(x=>x.classList.contains('active')));
   const buttons=[];
   const setIndex=(n)=>{
     index=Math.max(0,Math.min(n,items.length-1));
     items.forEach((item,i)=>item.classList.toggle('active',i===index));
     buttons.forEach((btn,i)=>btn.setAttribute('aria-current',String(i===index)));
     nav.ltBack.disabled=index===0;nav.ltNext.disabled=index===items.length-1;
     buttons[index]?.scrollIntoView({block:'nearest',inline:'nearest'});
     const image=items[index].querySelector('img');
     const limit=()=>{if(image?.naturalWidth)image.style.maxWidth=Math.min(image.naturalWidth,760)+'px';};
     if(image){if(image.complete)limit();else image.addEventListener('load',limit,{once:true});}
   };
   items.forEach((item,i)=>{
     const b=document.createElement('button');b.type='button';b.className='lt-gallery-thumb';b.setAttribute('aria-label','Mostra immagine '+(i+1));
     const img=item.querySelector('img');
     if(img){const copy=document.createElement('img');copy.src=img.currentSrc||img.src;copy.alt='';copy.loading='lazy';b.append(copy);}
     else b.textContent=String(i+1);
     b.addEventListener('click',()=>setIndex(i));strip.append(b);buttons.push(b);
   });
   nav.ltBack.onclick=()=>setIndex(index-1);nav.ltNext.onclick=()=>setIndex(index+1);
   if(this.ltGalleryKeydown)this.removeEventListener('keydown',this.ltGalleryKeydown);
   this.ltGalleryKeydown=e=>{if(e.key==='ArrowLeft'){e.preventDefault();setIndex(index-1)}if(e.key==='ArrowRight'){e.preventDefault();setIndex(index+1)}};
   this.addEventListener('keydown',this.ltGalleryKeydown);
   setIndex(index);nav.hidden=items.length<2;
 };
})();


/* LT-GALLERY-FIX2-20261018 */
(function(){
  const ctor=customElements.get('product-modal');
  if(ctor&&!ctor.prototype.ltFix2Installed){
    ctor.prototype.ltFix2Installed=true;
    const previous=ctor.prototype.show;
    ctor.prototype.show=function(opener){
      previous.call(this,opener);
      const nav=this.querySelector('.lt-gallery-nav');
      if(nav&&!nav.dataset.ltPointerFix){
        nav.dataset.ltPointerFix='1';
        nav.addEventListener('pointerup',event=>event.stopPropagation());
      }
      const box=this.querySelector('.product-media-modal__dialog');
      if(box&&!box.dataset.ltPointerFix){
        box.dataset.ltPointerFix='1';
        box.addEventListener('pointerup',event=>{
          if(event.target.closest('.lt-gallery-nav, .product-media-modal__content, .product-media-modal__toggle'))event.stopPropagation();
        });
      }
    };
  }
  const gallery=customElements.get('media-gallery');
  if(gallery&&!gallery.prototype.ltFix2Installed){
    gallery.prototype.ltFix2Installed=true;
    const set=gallery.prototype.setActiveMedia;
    gallery.prototype.setActiveMedia=function(mediaId,prepend){
      return set.call(this,mediaId,false);
    };
  }
  function restoreOrder(){
    document.querySelectorAll('media-gallery').forEach(g=>{
      const section=g.id.replace(/^MediaGallery-/,'');
      const modal=document.getElementById('ProductModal-'+section);
      if(!modal)return;
      const ids=[...modal.querySelectorAll('.product-media-modal__content > [data-media-id]')].map(n=>n.dataset.mediaId);
      if(!ids.length)return;
      const viewer=g.querySelector('[id^="Slider-Gallery-"]');
      const thumbs=g.querySelector('[id^="Slider-Thumbnails-"]');
      if(viewer){
        const elements=new Map([...viewer.children].filter(n=>n.dataset.mediaId).map(n=>[n.dataset.mediaId,n]));
        ids.forEach(id=>{const n=elements.get(id);if(n)viewer.appendChild(n);});
        const first=elements.get(ids[0]);
        if(first){
          [...elements.values()].forEach(n=>n.classList.toggle('is-active',n===first));
        }
      }
      if(thumbs){
        const elements=new Map([...thumbs.children].filter(n=>n.dataset.target).map(n=>[n.dataset.target,n]));
        ids.forEach(id=>{const n=elements.get(id);if(n)thumbs.appendChild(n);});
        [...elements.values()].forEach((n)=>{const b=n.querySelector('button');if(b){if(n.dataset.target===ids[0])b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');}});
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restoreOrder,{once:true});else restoreOrder();
})();